
import { useState } from 'react';

export const useLogoPreview = () => {
  const [logoPreview, setLogoPreview] = useState<string | null>(null);

  // Process a File object and convert it to a data URL
  const processLogo = async (file: File) => {
    if (!file) {
      setLogoPreview(null);
      return;
    }

    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("Error processing logo:", error);
      setLogoPreview(null);
    }
  };
  
  // Set the logo preview directly from a string URL
  const setLogoPreviewDirectly = (url: string) => {
    setLogoPreview(url);
  };

  const clearLogo = () => {
    setLogoPreview(null);
  };

  return {
    logoPreview,
    processLogo,
    clearLogo,
    setLogoPreviewDirectly
  };
};
